import { APIResponse, PaginatedAPIResponse } from "../../../models/NetworkResponse";
import { deleteAPI, getAPI, patchAPI, postAPI, putAPI } from "../../../api/Networking";
import { Customer, CustomerRequestBody } from "../../../models/Customer/Customer";
import { GetCustomerParams } from "../../../models/Customer/getCustomerParams";
import { CustomerActivityLog } from "../../../models/Customer/CustomerActivityLog";

export default class CustomerAPI {
  getCustomers = async (
    filter: GetCustomerParams
  ): Promise<PaginatedAPIResponse<Customer>> => {
    try {
      const queryParams = new URLSearchParams();

      if (filter.page_no) {
        queryParams.append("page_no", filter.page_no.toString());
      }
      if (filter.limit) queryParams.append("limit", filter.limit.toString());

      if (filter.search_text) {
        queryParams.append("search_text", filter.search_text);
      }

      if (filter.is_partner) {
        queryParams.append("is_partner", filter.is_partner ? "true" : "false");
      }

      if (filter.sort_by) queryParams.append("sort_by", filter.sort_by);
      if (filter.sort_type)
        queryParams.append("sort_type", filter.sort_type.toString());
      if (filter.active_status) {
        const activeQueryValue = {
          active: "true",
          inactive: "false",
          all: "all",
        }[filter.active_status];
        queryParams.append("active", activeQueryValue);
      }

      const response = await getAPI(`/v5/customers?${queryParams.toString()}`);

      return response.result as PaginatedAPIResponse<Customer>;
    } catch (error) {
      throw error;
    }
  };

  updateCustomerDetails = async (
    customerDetails: CustomerRequestBody
  ): Promise<APIResponse> => {
    try {
      const response = await putAPI(`/v5/customers`, customerDetails);
      return response;
    } catch (error) {
      throw error;
    }
  };

  getCustomerDetailsById = async (customerId: number) => {
    try {
      const response = await getAPI(`/v5/customers/${customerId}`);
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  createCustomer = async (
    customerDetails: CustomerRequestBody
  ): Promise<APIResponse> => {
    try {
      const response = await postAPI(`/v5/customers`, customerDetails);
      return response;
    } catch (error) {
      throw error;
    }
  };

  deleteCustomer = async (customerId: number): Promise<APIResponse> => {
    try {
      const response = await deleteAPI(`/v5/customers/${customerId}`);
      return response;
    } catch (error) {
      throw error;
    }
  };
  activateCustomer = async (customerId: number): Promise<APIResponse> => {
    try {
      const response = await patchAPI(`/v1/customer/${customerId}/activate`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  getCustomerActivityLogs = async (
    customerId: number,
  ): Promise<CustomerActivityLog[]> => {
    try {
      const response = await getAPI(`/v5/customers/${customerId}/activity-logs`);
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  generatePartnerApiKey = async (
    customerId: number,
    name?: string
  ): Promise<APIResponse> => {
    try {
      const response = await postAPI(
        `/v5/admins/customer_id/${customerId}/generate-pod-partner-api-key`,
        { name }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  getPartnerApiKeys = async (customerId: number): Promise<APIResponse> => {
    try {
      const response = await getAPI(`/v1/customer/${customerId}/api-keys`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  disablePartnerApiKey = async (
    customerId: number,
    keyId: number
  ): Promise<APIResponse> => {
    try {
      const response = await patchAPI(
        `/v1/customer/${customerId}/api-keys/${keyId}/disable`
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
}
